// https://karius.atlassian.net/wiki/spaces/ENG/pages/2125037724/Karius+Web+and+Mobile+Instrumentation (Most engagement events are here)

export enum EngagementEvents {
  access_revoked_tapped = 'access_revoked_tapped',
  account_locked_button_expired_shown = 'account_locked_button_expired_shown',
  account_locked_shown = 'account_locked_shown',
  all_orders_tapped = 'all_orders_tapped',
  edit_required_info_missing_shown = 'edit_required_info_missing_shown',
  edit_rim_go_back_to_editing_tapped = 'edit_rim_go_back_to_editing_tapped',
  edit_rim_update_order_tapped = 'edit_rim_update_order_tapped',
  edit_submitted_trf_tapped = 'edit_submitted_trf_tapped',
  edit_trf_viewed = 'edit_trf_viewed',
  error_link_tapped = 'error_link_tapped',
  error_shown = 'error_shown',
  footer_link_tapped = 'footer_link_tapped',
  ga_cancel_tapped = 'ga_cancel_tapped',
  ga_confirm_tapped = 'ga_confirm_tapped',
  ga_mrn_search_executed = 'ga_mrn_search_executed',
  ga_tapped = 'ga_tapped',
  global_menu_tapped = 'global_menu_tapped',
  icd_search_selection_tapped = 'icd_search_selection_tapped',
  inactivity_sign_out = 'inactivity_sign_out',
  inline_link_tapped = 'inline_link_tapped',
  inline_support_link_tapped = 'inline_support_link_tapped',
  kits_order_submission_failure = 'kits_order_submission_failure',
  kits_order_submission_successful = 'kits_order_submission_successful',
  login = 'login',
  mobile_app_download_tapped = 'mobile_app_download_tapped',
  nav_link_tapped = 'nav_link_tapped',
  need_help_accordion_tapped = 'need_help_accordion_tapped',
  need_help_link_tapped = 'need_help_link_tapped',
  next_page_tapped = 'next_page_tapped',
  no_biometric_profile_text_tapped = 'no_biometric_profile_text_tapped',
  notification_toggle_tapped = 'notification_toggle_tapped',
  on_privacy_policy_tapped = 'on_privacy_policy_tapped',
  on_tou_tapped = 'on_tou_tapped',
  onboarding_finished = 'onboarding_finished',
  onboarding_started = 'onboarding_started',
  order_another_test_tapped = 'order_another_test_tapped',
  order_details_page_load = 'order_details_page_load',
  order_details_viewed = 'order_details_viewed',
  order_kits_tapped = 'order_kits_tapped',
  order_kits_viewed = 'order_kits_viewed',
  order_tapped = 'order_tapped',
  orders_list_viewed = 'orders_list_viewed',
  orders_scroll_data_load = 'orders_scroll_data_load',
  other_order_tapped = 'other_order_tapped',
  place_order_tapped = 'place_order_tapped',
  previous_page_tapped = 'previous_page_tapped',
  print_test_requisition_form_tapped = 'print_test_requisition_form_tapped',
  privacy_tapped = 'privacy_tapped',
  push_notification_received = 'push_notification_received',
  push_notification_sent = 'push_notification_sent',
  push_notification_tapped = 'push_notification_tapped',
  push_notifications_not_enabled_tapped = 'push_notifications_not_enabled_tapped',
  remember_username_tapped = 'remember_username_tapped',
  report_download_tapped = 'report_download_tapped',
  reprint_requisition_tapped = 'reprint_requisition_tapped',
  required_info_missing_shown = 'required_info_missing_shown',
  reset_password_cancel_tapped = 'reset_password_cancel_tapped',
  reset_password_email_sent_viewed = 'reset_password_email_sent_viewed',
  reset_password_or_unlock_successful = 'reset_password_or_unlock_successful',
  reset_password_submit_tapped = 'reset_password_submit_tapped',
  reset_password_tapped = 'reset_password_tapped',
  revoke_access_tapped = 'revoke_access_tapped',
  rim_go_back_to_form_tapped = 'rim_go_back_to_form_tapped',
  rim_place_order_tapped = 'rim_place_order_tapped',
  rows_per_page_adjusted = 'rows_per_page_adjusted',
  specimen_processing_instructions_tapped = 'specimen_processing_instructions_tapped',
  search_cancel_tapped = 'search_cancel_tapped',
  search_executed = 'search_executed',
  search_tapped = 'search_tapped',
  security_toggle_tapped = 'security_toggle_tapped',
  sign_in_tapped = 'sign_in_tapped',
  sign_out_tapped = 'sign_out_tapped',
  supplied_info_invalid = 'supplied_info_invalid',
  support_link_tapped = 'support_link_tapped',
  support_tapped = 'support_tapped',
  table_sort_tapped = 'table_sort_tapped',
  text_PHI_alert_tapped = 'text_PHI_alert_tapped',
  three_dot_menu_tapped = 'three_dot_menu_tapped',
  toast_revoke_access_tapped = 'toast_revoke_access_tapped',
  tou_tapped = 'tou_tapped',
  trf_mrn_lookup_successful = 'trf_mrn_lookup_successful',
  trf_submission_successful = 'trf_submission_successful',
  trf_submitted_viewed = 'trf_submitted_viewed',
  trf_update_successful = 'trf_update_successful',
  trf_viewed = 'trf_viewed',
  update_order_tapped = 'update_order_tapped',
  user_profile_tapped = 'user_profile_tapped',
  users_and_permissions_viewed = 'users_and_permissions_viewed',
}
